import { useMemo } from 'react';

import { MarginInstrument } from '@swyftx/margin/build/types';

import { useMarkets } from 'src/lib/markets/hooks/useMarkets';

type Props = {
  instrument?: MarginInstrument;
};

const useMarginInstrumentDetails = ({ instrument }: Props) => {
  const { getAssetByUuid, getAssetsByUuid } = useMarkets();

  const primaryAsset = instrument ? getAssetByUuid(instrument.primaryAssetUuid) : undefined;

  const secondaryAsset = instrument ? getAssetByUuid(instrument.secondaryAssetUuid) : undefined;

  const symbol = instrument
    ? getAssetsByUuid([instrument.secondaryAssetUuid, instrument.primaryAssetUuid])
        .map((a) => a.code)
        .join('')
    : undefined;

  const name = instrument
    ? getAssetsByUuid([instrument.secondaryAssetUuid, instrument.primaryAssetUuid])
        .map((a) => a.name)
        .join(' / ')
    : undefined;

  const priceScale = useMemo(
    () => instrument?.minLotIncrement.split('.')?.[1]?.length || 0,
    [instrument?.minLotIncrement],
  );

  return {
    primaryAsset,
    secondaryAsset,
    symbol,
    priceScale,
    name,
  };
};

export { useMarginInstrumentDetails };
